import React from 'react';
import styles from './DocumentPage.module.css';

interface Section {
  heading: string;
  content: string;
}

interface Props {
  title: string;
  sections: Section[];
}

const DocumentPage: React.FC<Props> = ({ title, sections }) => {
  return (
    <div className={styles.container}>
      <h1>{title}</h1>
      {sections.map((section, index) => (
        <div key={index} className={styles.section}>
          <h2>{section.heading}</h2>
          <p>{section.content}</p>
        </div>
      ))}
    </div>
  );
};

export default DocumentPage;
